<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import RepairFileService from '@/services/RepairFileService'
import PdfService from '@/services/PdfService'
import { displayToast, handleResponseError, shouldShowTooltip } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'GuaranteeExtensionBoomerangModal',
  components: { DialogCloseButton, PopupModal },
  data: () => ({
    loading: false,

    repairFile: null,
    sendEmail: false,

    formValid: false,
    contactEmail: null,
    endExtensionDate: '##/##/####',

    requiredRules: Validator.requiredRules,
    emailRules: Validator.emailRules,

    error: null
  }),
  methods: {
    shouldShowTooltip,
    async show(opts = {}) {
      this.repairFileBoomerangId = opts.repairFileBoomerangId
      try {
        this.repairFile = await RepairFileService.get(this.repairFileBoomerangId)
        this.contactEmail = this.repairFile.email
        this.endExtensionDate = this.repairFile.guarantee_extension_boomerang_end_date

        if (this.endExtensionDate != null) {
          this.$refs.popup.open()

          return new Promise((resolve, reject) => {
            this.resolvePromise = resolve
            this.rejectPromise = reject
          })
        }
      } catch (error) {
        handleResponseError(error)
      }
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise(true)
    },
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
    },
    async getGuaranteeExtensionBoomerangPdf() {
      try {
        this.loading = true
        const response = await PdfService.getGuaranteeExtensionBoomerangPdf(
          this.repairFile.boomerang_id
        )
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          'certificat_prolongation_garantie_boomerang_' +
            this.repairFile.internal_command_number +
            '.pdf'
        )
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async callSendEmailAndClose() {
      try {
        this.loading = true
        await RepairFileService.sendGuaranteeExtensionBoomerangByEmail(
          this.contactEmail,
          this.repairFile.boomerang_id
        )

        displayToast(this.$t('GUARANTEE_EXTENSION_BOOMERANG_MODAL.SUCCESS_SENT'), 'success')
        this._confirm()
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <popup-modal ref="popup">
    <v-form ref="form" v-model="formValid" @submit.prevent="callSendEmailAndClose">
      <DialogCloseButton :close-method="_cancel" />

        <div class="content-title">
          {{ $t('GUARANTEE_EXTENSION_BOOMERANG_MODAL.TITLE') }}
        </div>

        <div class="content-body mt-3">
          {{ $t('GUARANTEE_EXTENSION_BOOMERANG_MODAL.BODY_1') }} {{ this.endExtensionDate }}.
          {{ $t('GUARANTEE_EXTENSION_BOOMERANG_MODAL.BODY_2') }}
        </div>

        <v-row class="card-box mt-5 mb-5">
          <v-card
            link
            :disabled="loading"
            @click.stop.prevent="getGuaranteeExtensionBoomerangPdf()"
            class="content-card rounded-xl flex-fill"
          >
            <v-row class="flex-column justify-center">
              <img
                alt="dialog-icon"
                class="svg-check-rounded mb-2"
                src="@/assets/icons/file/file.svg"
              />
              <div class="text-decoration-underline d-flex flex-column justify-center align-center">
                {{ $t('GUARANTEE_EXTENSION_BOOMERANG_MODAL.PROOF_TITLE') }}
              </div>
            </v-row>
          </v-card>
        </v-row>

        <div class="checkbox-custom">
          <v-col md="1" class="pa-0">
            <v-checkbox hide-details color="#559a1b" v-model="sendEmail" class="checkbox" />
          </v-col>
          <v-col class="checkbox pb-0 pt-4 pl-0">
            <p>{{ $t('GUARANTEE_EXTENSION_BOOMERANG_MODAL.SEND_BY_EMAIL_MESSAGE') }}</p>
          </v-col>
        </div>

        <div v-if="sendEmail === true">
          <div class="mb-2">
            <!--Contact email-->
            <v-text-field
              v-model="contactEmail"
              :rules="[...requiredRules, ...emailRules]"
              :placeholder="
                $t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.PLACEHOLDER.EMAIL_CONTACT')
              "
              :error-messages="error?.contact_email"
              required
            />
          </div>

          <div class="d-flex justify-center">
            <v-btn
              :disabled="!formValid || loading"
              :loading="loading"
              class="boom-button dialog-button"
              variant="outlined"
              type="submit"
            >
              {{ $t('COMMON.BUTTON.VALIDATE') }}
              <template v-slot:prepend>
                <img
                  alt="send-icon"
                  :class="!formValid ? 'send-green-svg' : 'send-white-svg'"
                  src="@/assets/icons/file/send.svg"
                />
              </template>
            </v-btn>
          </div>
        </div>
    </v-form>
  </popup-modal>
</template>

<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-card {
  display: flex;
  width: 135px;
  height: 122px;
  padding: 20px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10%;
  margin-right: 10%;
  border-radius: 20px;
  border: 1px solid #dadada;
  background: #fff;
  /* Light dropdown shadow */
  box-shadow: 6px 6px 12px 0 rgba(218, 218, 218, 0.4);
}

.card-box {
  display: flex;
  width: 80%;
  margin: auto;
}

.content-title {
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.checkbox-custom {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
}

.send-white-svg {
  height: 100%;
  width: 100%;
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}

.send-green-svg {
  height: 100%;
  width: 100%;
  filter: invert(47%) sepia(77%) saturate(455%) hue-rotate(50deg) brightness(93%) contrast(92%);
}
</style>
